module.exports = __webpack_public_path__ + "img/Sibiu_a_kl.6972121f.jpg";